var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnsiteIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35526 3.689C8.05127 0.99299 12.4224 0.99299 15.1184 3.689C17.8144 6.38501 17.8144 10.7561 15.1184 13.4521L10.2368 18.3337L5.35526 13.4521C2.65925 10.7561 2.65925 6.38501 5.35526 3.689ZM10.2368 10.543C11.3262 10.543 12.2093 9.6599 12.2093 8.57055C12.2093 7.4812 11.3262 6.59811 10.2368 6.59811C9.14746 6.59811 8.26437 7.4812 8.26437 8.57055C8.26437 9.6599 9.14746 10.543 10.2368 10.543Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnsiteIconBlack);
export default __webpack_public_path__ + "static/media/onsite-icon-black.b898e8b69ed298a3df4ec2f109fd78b0.svg";
export { ForwardRef as ReactComponent };